import { UntitledIcon } from '@faceup/icons'
import { ulPlus } from '@faceup/icons/ulPlus'
import { defineMessages, FormattedMessage } from '@faceup/localization'
import { useNavigate } from '@faceup/router'
import { Button, Col, Row, Space, Typography } from '@faceup/ui-base'
import { useSavedReportsContext } from '../../hooks/useSavedReportsContext'
import { ReportInfo } from './components'

const messages = defineMessages('followUp.pages.checkReportList', [
  { id: 'title', defaultMessage: '' },
  { id: 'checkAnotherReport', defaultMessage: '' },
] as const)

export const CheckReportList = () => {
  const { reports, loginIntoReport } = useSavedReportsContext()
  const navigate = useNavigate()

  return (
    <Space direction='vertical' size='large' className='w-full'>
      <Row justify='space-between' align='middle' className='mb-4'>
        <Col>
          <Typography.Title level={4}>
            <FormattedMessage message={messages.title} />
          </Typography.Title>
        </Col>
        <Col>
          <Button
            onClick={() => navigate(routes => routes.checkReportForm())}
            icon={<UntitledIcon icon={ulPlus} />}
          >
            <FormattedMessage message={messages.checkAnotherReport} />
          </Button>
        </Col>
      </Row>
      <Space direction='vertical' size='large' className='w-full'>
        {reports.map(report => (
          <ReportInfo
            key={report.id}
            report={report}
            onClick={async () => {
              await loginIntoReport(report)
              navigate(routes => routes.report())
            }}
          />
        ))}
      </Space>
    </Space>
  )
}
